import React, {Component} from 'react';
import {browserHistory} from 'react-router';
import {message} from 'antd';
import moment from 'moment';

import {queryCallbackAdjustment, queryNextAdjustment, queryReturnAdjustment} from '@api/finance/budget';
import Opration from '@comm/workflow/WorkflowOp';
import PageDetails from './PageDetails';

class Page extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataInfo: {},
      isLoading: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { data } = this.props;
    this.setState({ dataInfo: data });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataInfo: nextProps.data,
    });
  }

  /**
   * 处理流程
   */
  doTask = (pass, refuse) => {
    const { dataInfo } = this.state;
    const instance = dataInfo.instance || {};
    const item = {
      instanceUuid: instance.uuid,
    };
    switch (pass) {
      case 'callback':
        this.callbackAdjustment(item);
        break;
      case 'next':
        this.nextAdjustment(item);
        break;
      case 'return':
        this.returnAdjustment(item, refuse);
        break;
      default:
        break;
    }
  };

  // 收回
  callbackAdjustment = params => {
    queryCallbackAdjustment(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  // 通过
  nextAdjustment = params => {
    this.setState({ isLoading: true });
    queryNextAdjustment(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.setState({ isLoading: false });
        browserHistory.go(-1);
      } else {
        message.error(res.message);
        this.setState({ isLoading: false });
      }
    });
  };

  // 打回
  returnAdjustment = (params, refuse) => {
    queryReturnAdjustment({
      ...params,
      ...refuse,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  handleCancel = () => {};

  /**
   * 查看流程
   */
  watchTask = () => {};

  columns = () => {
    return [
      {
        title: '日期',
        dataIndex: 'date',
        render: text => (
          <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null}</span>
        ),
      },
      {
        title: '操作内容',
        dataIndex: 'operating',
      },
      {
        title: '处理意见',
        dataIndex: 'refuse',
      },
    ];
  };

  render() {
    const { dataInfo, isLoading } = this.state;
    return (
      <div>
        <Opration
          data={dataInfo}
          doTask={this.doTask}
          watchTask={this.watchTask}
          isLoading={isLoading}
        />
        <PageDetails data={dataInfo} {...this.props} />
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/finance/budget/adjust/PageOpen.js